import { Box } from '@deckee/deck-hand';
import React, { FC, useMemo, useState } from 'react';
import { getLayerDefinitions } from '../../../../services/map-layer';
import { buildWaypointGroups } from '../mapSettingsConfig';
import WaypointGroup from './WaypointGroup';

interface WaypointsTabProps {
  selectedLayerTypes: Set<string>;
  onToggleLayer: (_layerName: string) => void;
}

/** Marker types, grouped by the category each one already belongs to. */
const WaypointsTab: FC<WaypointsTabProps> = ({
  selectedLayerTypes,
  onToggleLayer,
}) => {
  const groups = useMemo(() => buildWaypointGroups(getLayerDefinitions()), []);

  const [expandedGroups, setExpandedGroups] = useState<Record<string, boolean>>(
    // The first category is open so the tab does not read as empty.
    () => (groups.length ? { [groups[0].owningMenu]: true } : {}),
  );

  const handleToggleExpanded = (owningMenu: string) =>
    setExpandedGroups((current) => ({
      ...current,
      [owningMenu]: !current[owningMenu],
    }));

  return (
    <Box display="flex" flexDirection="column" gap={2.5}>
      {groups.map((group) => (
        <WaypointGroup
          key={group.owningMenu}
          group={group}
          expanded={!!expandedGroups[group.owningMenu]}
          onToggleExpanded={handleToggleExpanded}
          selectedLayerTypes={selectedLayerTypes}
          onToggleLayer={onToggleLayer}
        />
      ))}
    </Box>
  );
};

export default WaypointsTab;
